const variables = {
    tablet_breakpoint_width: 768,
    desktop_breakpoint_width: 1024,
    desktop_max_width: 1440
};

export default variables;

export  const zIndices = {
    elementZIndex1: 1,
    elementZIndex2: 2,
    elementZIndex3: 2,
    elementZIndex4: 2
};